"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ArticlesSection = require("./ArticlesSection");
Object.keys(_ArticlesSection).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ArticlesSection[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ArticlesSection[key];
    }
  });
});
var _ArticlesSectionSkeleton = require("./ArticlesSectionSkeleton");
Object.keys(_ArticlesSectionSkeleton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ArticlesSectionSkeleton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ArticlesSectionSkeleton[key];
    }
  });
});
var _CategoriesSection = require("./CategoriesSection");
Object.keys(_CategoriesSection).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CategoriesSection[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _CategoriesSection[key];
    }
  });
});
var _CategoriesSectionSkeleton = require("./CategoriesSectionSkeleton");
Object.keys(_CategoriesSectionSkeleton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CategoriesSectionSkeleton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _CategoriesSectionSkeleton[key];
    }
  });
});
var _Description = require("./Description");
Object.keys(_Description).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Description[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Description[key];
    }
  });
});
var _DescriptionSkeleton = require("./DescriptionSkeleton");
Object.keys(_DescriptionSkeleton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DescriptionSkeleton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DescriptionSkeleton[key];
    }
  });
});
var _Title = require("./Title");
Object.keys(_Title).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Title[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Title[key];
    }
  });
});
var _TitleSkeleton = require("./TitleSkeleton");
Object.keys(_TitleSkeleton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TitleSkeleton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TitleSkeleton[key];
    }
  });
});
var _mocks = require("./mocks");
Object.keys(_mocks).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _mocks[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _mocks[key];
    }
  });
});
var _types = require("./types");
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _types[key];
    }
  });
});
var _EditorialCarouselSection = require("./EditorialCarouselSection");
Object.keys(_EditorialCarouselSection).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _EditorialCarouselSection[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _EditorialCarouselSection[key];
    }
  });
});
var _EditorialCarouselSectionSkeleton = require("./EditorialCarouselSectionSkeleton");
Object.keys(_EditorialCarouselSectionSkeleton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _EditorialCarouselSectionSkeleton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _EditorialCarouselSectionSkeleton[key];
    }
  });
});
